import { useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore } from '../stores';
import { FullPageSpinner } from '../components';
import { api } from '../lib/api';
import Sidebar from './components/Sidebar';
import Topbar from './components/Topbar';

export default function DashboardLayout() {
  const { isAuthenticated, user, clearAuth, mustChangePassword } = useAuthStore();
  const location = useLocation();
  const [validating, setValidating] = useState(true);

  // Validate token on mount — catch expired sessions before rendering
  useEffect(() => {
    if (!isAuthenticated) {
      setValidating(false);
      return;
    }

    api.get('/auth/me')
      .then(() => setValidating(false))
      .catch(() => {
        clearAuth();
        setValidating(false);
      });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (validating) {
    return <FullPageSpinner text="Loading..." />;
  }

  // Redirect to login if not authenticated, then back here afterwards
  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  // Show loading while fetching user
  if (!user) {
    return <FullPageSpinner text="Loading..." />;
  }

  // Force password change before accessing dashboard
  if (mustChangePassword) {
    return <Navigate to="/change-password" replace />;
  }

  return (
    <div className="flex h-dvh overflow-hidden bg-paper">
      {/* Sidebar */}
      <Sidebar />

      {/* Main Content */}
      <div className="flex flex-1 flex-col overflow-hidden">
        {/* Topbar */}
        <Topbar />

        {/* Page Content */}
        <main className="min-w-0 flex-1 overflow-y-auto overflow-x-hidden">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
